const get = store => store.product || {};
export const searchProduct = store => (store ? store : { data: [] });
export const getProduct = store => get(store).product;
export const isLoaded = store => get(store).isLoaded === true;
export const getAttrs = store => get(store).attributes;
export const getCategories = store => get(store).categories;
